import { useEffect, useRef, useState } from "react";
import { card1Frames } from "../animations/heroCardAnimations";
import { cardKeyframes } from "../animations/heroCardAnimations";

const useHeroLogic = () => {
  const [screenSize, setScreenSize] = useState("desktop");
  const [card1CurrentFrame, setCard1CurrentFrame] = useState(0);
  const [isHeroVisible, setIsHeroVisible] = useState(false);
  const heroRef = useRef(null);

  // 📱 Detecta o tamanho da tela
  useEffect(() => {
    const updateScreenSize = () => {
      if (window.innerWidth <= 768) setScreenSize("mobile");
      else if (window.innerWidth <= 1024) setScreenSize("tablet");
      else setScreenSize("desktop");
    };

    updateScreenSize();
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  // 👁️ Observa se o hero está visível na tela
  useEffect(() => {
    if (!heroRef.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => setIsHeroVisible(entry.isIntersecting),
      { threshold: 0.5 }
    );

    observer.observe(heroRef.current);
    return () => observer.disconnect();
  }, []);

  // 🌀 Animação com controle de visibilidade e reverso
  useEffect(() => {
    if (!isHeroVisible) return;
  
    let frame = 0;
    let cycleCount = 0;
    let intervalId = null;
    let timeoutId = null;
  
    const runAnimation = () => {
      intervalId = setInterval(() => {
        setCard1CurrentFrame(frame);
        frame++;
  
        if (frame >= card1Frames.length) {
          cycleCount++;
          frame = 0;
  
          if (cycleCount >= 3) {
            clearInterval(intervalId);
  
            timeoutId = setTimeout(() => {
              cycleCount = 0;
              runAnimation();
            }, 2000);
          }
        }
      }, 100); // velocidade entre frames
    };
  
    runAnimation();
  
    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [isHeroVisible]);  

  // 🧩 Injeta os keyframes no DOM uma única vez
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = cardKeyframes;
    document.head.appendChild(styleTag);

    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  return { screenSize, card1CurrentFrame, isHeroVisible, heroRef };
};

export default useHeroLogic;
